module.exports = "<div *ngIf=\"displayError\" >\r\n  <span class=\"glyphicon glyphicon-remove form-control-feedback fix-error-icon\"></span>\r\n  <span class=\"sr-only\">(error)</span>\r\n  <div class=\"error-msg\">\r\n    {{ errorMsg }}\r\n  </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/field-error-display/field-error-display.component.html
// module id = ./src/app/field-error-display/field-error-display.component.html
// module chunks = main